import { useLayoutEffect, useState } from 'react'
import { TREE_STATS_BAR_CLASS } from '../components/MapboxGL/controls/TreeStatsBarControl'

const ANCHOR_GAP_PX = 8

/**
 * Calcula, en coordenadas de viewport, el punto justo encima del
 * TreeStatsBarControl para anclar elementos flotantes sobre él.
 * Se mide cada vez que `active` pasa a true. Devuelve null si el control
 * no está montado (p. ej. con hideStats), para que el consumidor use su
 * posición por defecto.
 */
export const useTreeStatsBarAnchor = (map, active) => {
  const [anchorPosition, setAnchorPosition] = useState(null)

  useLayoutEffect(() => {
    if (!active || !map) return

    const statsBarElement = map.getContainer().querySelector(`.${TREE_STATS_BAR_CLASS}`)
    if (!statsBarElement) {
      setAnchorPosition(null)
      return
    }

    const { top, left, width } = statsBarElement.getBoundingClientRect()
    setAnchorPosition({
      bottom: window.innerHeight - top + ANCHOR_GAP_PX,
      centerX: left + width / 2,
    })
  }, [map, active])

  return anchorPosition
}

export default useTreeStatsBarAnchor
